<div class="component-container">
  <div *ngIf="preview && !formfinished && !readonly && !isViewMode" style="margin-bottom: 10px;">
      <button type="button" class="small-button" (click)="toggleJsonEditor()">
        {{ 'form.list.edit_config_json' | translate }}
      </button>

      <div *ngIf="showJsonEditor" class="config-json-editor">
        <textarea [(ngModel)]="configJSON" rows="10" cols="50" style="width: 100%;"></textarea>
        <br />
        <button type="button" class="small-button" (click)="reloadForm()">{{ 'form.dynamic.reload_form' | translate }}</button>
      </div>

  </div>


  <div *ngIf="!formfinished">
    <!-- 只有在 formGroup 初始化完成後才渲染表單 -->
    <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="onSubmit()">

      <div *ngIf="preview; else viewMode">
        <div class="form-section">
          <label>{{ 'form.list.form_name_label' | translate }}</label>
          <input type="text" [(ngModel)]="formName" [ngModelOptions]="{standalone: true}" class="form-input" />
        </div>
      </div>
      <ng-template #viewMode>
        <!-- <h3>{{ formName }}</h3> -->
      </ng-template>

      <!-- 階段進度條 -->
      <app-stage-progress
        *ngIf="!preview && !formfinished && formStages.length > 0"
        [stages]="formStages"
        [currentStageIndex]="currentStageIndex">
      </app-stage-progress>

      <!-- 當前階段資訊 -->
      <div class="current-stage-info" *ngIf="currentStage && !preview && !formfinished">
        <div class="stage-card">
          <h4><i class="fas fa-tasks"></i> {{ currentStage.name }}</h4>
          <p *ngIf="currentStage.description">{{ currentStage.description }}</p>
          <div class="stage-meta">
            <span class="department-tag" *ngFor="let dept of currentStage.requiredDepartments">
              <i class="fas fa-users"></i> {{ dept }}
            </span>
          </div>
        </div>
      </div>

      <ng-container *ngFor="let section of getFilteredSectionsByStage()">
        <!-- 段落標題 -->
        <div *ngIf="section.sectionHeader" class="form-field">
          <app-form-paragraph
            [label]="section.sectionHeader.label"
            [id]="section.sectionHeader.id"
            [name]="section.sectionHeader.name"
            [content]="section.sectionHeader.content || ''"
            [textAlign]="section.sectionHeader.textAlign || 'left'"
            [isSectionHeader]="true"
            [showQuestionCount]="section.fields.length > 0"
            [completedCount]="section.completedCount"
            [totalCount]="section.totalCount"
            [isExpanded]="section.isExpanded"
            (toggleExpanded)="onSectionToggle($event)"
            formControlName="{{ section.sectionHeader.name }}">
          </app-form-paragraph>
        </div>

        <!-- 段落下的表單欄位 -->
        <ng-container *ngIf="!section.sectionHeader || section.isExpanded">
          <ng-container *ngFor="let field of section.fields">
            <div class="form-field" [ngSwitch]="field.type" [attr.data-field-name]="field.name" [class.field-error]="isFieldInvalid(field)">
              <!-- 時間元件 -->
              <app-form-datetime *ngSwitchCase="'datetime'" [label]="field.label" [id]="field.id" [name]="field.name"
                [required]="field.required || false" [readonly]="readonly || isViewMode" formControlName="{{ field.name }}">
              </app-form-datetime>

              <!-- 下拉選單元件 -->
              <app-form-select *ngSwitchCase="'select'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [options]="field.options || []" [required]="field.required || false"
                [readonly]="readonly || isViewMode" formControlName="{{ field.name }}">
              </app-form-select>

              <!-- 動態API下拉選單元件 -->
              <app-form-dynamic-api-select *ngSwitchCase="'dynamic-api-select'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [apiKey]="field.apiKey || ''" [required]="field.required || false" formControlName="{{ field.name }}">
              </app-form-dynamic-api-select>

              <!-- 動態API表格選擇元件 -->
              <app-form-dynamic-api-table *ngSwitchCase="'dynamic-api-table'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [apiKey]="field.apiKey || ''" [maxSelections]="field.maxSelections || 0" [required]="field.required || false" formControlName="{{ field.name }}">
              </app-form-dynamic-api-table>

              <!-- 自動編號元件 -->
              <app-form-auto-numbering *ngSwitchCase="'auto-numbering'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [config]="field.autoNumbering || { elements: [] }" [required]="field.required || false" [readonly]="readonly || isViewMode" formControlName="{{ field.name }}">
              </app-form-auto-numbering>

              <!-- 單選按鈕元件 -->
              <app-form-radiobutton *ngSwitchCase="'radiobutton'" [label]="field.label" [placeholder]="field.placeholder || ''" [id]="field.id" [name]="field.name"
                [options]="field.options || []" [conditionalInputs]="field.conditionalInputs || null"
                [questionImageUrl]="field.questionImageUrl" [questionImageBlobName]="field.questionImageBlobName" [questionImageAltText]="field.questionImageAltText"
                [required]="field.required || false" [readonly]="readonly || isViewMode" formControlName="{{ field.name }}">
              </app-form-radiobutton>

              <!-- 文字輸入元件 -->
              <app-form-text-input *ngSwitchCase="'text-input'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [required]="field.required || false"
                [readonly]="readonly || isViewMode" formControlName="{{ field.name }}">
              </app-form-text-input>

              <!-- 數字輸入元件 -->
              <app-form-number-input *ngSwitchCase="'number-input'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [required]="field.required || false" formControlName="{{ field.name }}">
              </app-form-number-input>

              <!-- 文字區塊元件 -->
              <app-form-textarea *ngSwitchCase="'textarea'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [required]="field.required || false"
                [readonly]="readonly || isViewMode" formControlName="{{ field.name }}">
              </app-form-textarea>

              <!-- GPS 定位元件 -->
              <app-form-location *ngSwitchCase="'location'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [required]="field.required || false" formControlName="{{ field.name }}">
              </app-form-location>

              <!-- 照片上傳元件 -->
              <app-form-photo-upload *ngSwitchCase="'photo-upload'" [label]="field.label" [id]="field.id"
                [name]="field.name" [required]="field.required || false" formControlName="{{ field.name }}">
              </app-form-photo-upload>

              <!-- 大頭照上傳元件 -->
              <app-form-avatar-upload *ngSwitchCase="'avatar-upload'" [label]="field.label" [id]="field.id"
                [name]="field.name" [required]="field.required || false"
                [maxFileSize]="field.maxFileSize || 5"
                [acceptedFormats]="field.acceptedFormats || ['.jpg', '.jpeg', '.png', '.gif']"
                [displayMode]="field.displayMode || 'square'"
                [placeholder]="field.placeholder || ('form.dynamic.avatar_upload_placeholder' | translate)"
                formControlName="{{ field.name }}">
              </app-form-avatar-upload>

              <!-- 日期選擇元件 -->
              <app-form-date *ngSwitchCase="'date'" [label]="field.label" [id]="field.id" [name]="field.name"
                placeholder="{{ field.placeholder }}" [required]="field.required || false"
                [readonly]="readonly || isViewMode" formControlName="{{ field.name }}">
              </app-form-date>

              <!-- 多選核取元件 -->
              <app-form-multi-checkbox *ngSwitchCase="'multi-checkbox'" [label]="field.label" [id]="field.id"
                [name]="field.name" [options]="field.options" [required]="field.required || false"
                [readonly]="readonly || isViewMode" formControlName="{{ field.name }}">
              </app-form-multi-checkbox>

              <!-- 簽名元件 -->
              <app-form-signature *ngSwitchCase="'signature'" [label]="field.label" [id]="field.id" [name]="field.name"
                [required]="field.required || false" formControlName="{{ field.name }}">
              </app-form-signature>

              <!-- 時間戳記元件 -->
              <app-form-timestamp *ngSwitchCase="'timestamp'" [label]="field.label" [id]="field.id" [name]="field.name"
                [format]="field.format || 'datetime'" formControlName="{{ field.name }}">
              </app-form-timestamp>

              <!-- 部門選擇器元件 -->
              <app-form-department-selector *ngSwitchCase="'department-selector'" [label]="field.label" [id]="field.id" [name]="field.name"
                [placeholder]="field.placeholder || ('form.dynamic.department_selector_placeholder' | translate)" formControlName="{{ field.name }}">
              </app-form-department-selector>

              <!-- 人員選擇器元件 -->
              <app-form-personnel-selector *ngSwitchCase="'personnel-selector'" [label]="field.label" [id]="field.id" [name]="field.name"
                [placeholder]="field.placeholder || ('form.dynamic.personnel_selector_placeholder' | translate)" [multiSelect]="field.multiSelect || false" formControlName="{{ field.name }}">
              </app-form-personnel-selector>

              <!-- Tags 標籤元件 -->
              <app-form-tags *ngSwitchCase="'tags'" [label]="field.label" [id]="field.id" [name]="field.name"
                [placeholder]="field.placeholder || ('form.dynamic.tags_placeholder' | translate)" [options]="field.options || []" [required]="field.required || false" formControlName="{{ field.name }}">
              </app-form-tags>

              <!-- 簽核流程選擇元件 -->
              <app-form-approval-flow *ngSwitchCase="'approval-flow'" [label]="field.label" [id]="field.id" [name]="field.name"
                [placeholder]="field.placeholder || ('form.dynamic.approval_flow_placeholder' | translate)" [required]="field.required || false" [preview]="true"
                [approvalFlowId]="field.approvalFlowId" formControlName="{{ field.name }}"
                [getuserlist]="getuseridlist" [initiatorInfo]="initiatorInfo"
                >
              </app-form-approval-flow>

              <!-- 檔案顯示元件 -->
              <app-file-display *ngSwitchCase="'file-display'" [label]="field.label" [id]="field.id" [name]="field.name"
                [required]="field.required || false" [preview]="preview" formControlName="{{ field.name }}">
              </app-file-display>

              <!-- 檔案上傳管理元件 -->
              <app-file-upload-manager *ngSwitchCase="'file-upload-manager'" [label]="field.label" [id]="field.id" [name]="field.name"
                [required]="field.required || false"  [preview]="preview" [config]="field.fileUploadConfig || {}"
                [files]="field.files ? convertToFileItems(field.files) : []"
                formControlName="{{ field.name }}">
              </app-file-upload-manager>

              <!-- 指定證件上傳元件 -->
              <app-form-required-document-upload *ngSwitchCase="'required-document-upload'"
                [label]="field.label" [id]="field.id" [name]="field.name"
                [required]="field.required || false"
                [config]="field.requiredDocumentConfig || {}"
                formControlName="{{ field.name }}">
              </app-form-required-document-upload>

              <!-- YouTube 影片播放器元件 -->
              <app-form-video-player *ngSwitchCase="'video-player'" [label]="field.label" [id]="field.id" [name]="field.name"
                [required]="field.required || false"
                [youtubeUrl]="field.youtubeUrl || ''"
                [videoTitle]="field.videoTitle || ''"
                [videoDescription]="field.videoDescription || ''"
                [videoWidth]="field.videoWidth || '100%'"
                [videoHeight]="field.videoHeight || '315px'"
                [videoAutoplay]="field.videoAutoplay || false"
                [videoControls]="field.videoControls !== false"
                [videoAllowFullscreen]="field.videoAllowFullscreen !== false"
                formControlName="{{ field.name }}">
              </app-form-video-player>
              <!-- 錄音元件 -->
              <app-form-audio-recorder *ngSwitchCase="'audio-recorder'" [label]="field.label" [id]="field.id" [name]="field.name"
                [placeholder]="field.placeholder || ('form.dynamic.audio_recorder_placeholder' | translate)" [required]="field.required || false"
                [maxDuration]="field.maxDuration || 300" [minDuration]="field.minDuration || 1"
                [audioQuality]="field.audioQuality || 'medium'" [audioFormat]="field.audioFormat || 'wav'"
                formControlName="{{ field.name }}">
              </app-form-audio-recorder>

              <!-- 多人簽名收集元件 -->
              <app-meeting-signature-collection *ngSwitchCase="'meeting-signature-collection'"
                [documentId]="field.documentId || 'form_' + field.id"
                [title]="field.title || field.label"
                (signaturesUpdated)="onSignaturesUpdated(field.name, $event)">
              </app-meeting-signature-collection>

              <!-- 填空元件 -->
              <app-fill-in-field *ngSwitchCase="'fill-in'"
                [label]="field.label"
                [id]="field.id"
                [name]="field.name"
                [template]="field.template || ''"
                [fields]="field.fields || []"
                [required]="field.required || false"
                [preview]="preview"
                formControlName="{{ field.name }}">
              </app-fill-in-field>

              <!-- 富文本顯示元件 -->
              <app-form-rich-text-display *ngSwitchCase="'rich-text-display'"
                [label]="field.label"
                [id]="field.id"
                [name]="field.name"
                [content]="field.content || ''"
                [fontSize]="field.fontSize || '14px'"
                [color]="field.color || '#333333'"
                [textAlign]="field.textAlign || 'left'"
                [lineHeight]="field.lineHeight || '1.5'"
                [maxWidth]="field.maxWidth || '100%'"
                [backgroundColor]="field.backgroundColor"
                [padding]="field.padding"
                [borderRadius]="field.borderRadius"
                formControlName="{{ field.name }}">
              </app-form-rich-text-display>

              <!-- 子表單關聯元件 -->
              <ng-container *ngSwitchCase="'subform-relation'">
                <app-form-subform-relation *ngIf="preview"
                  [label]="field.label"
                  [id]="field.id"
                  [name]="field.name"
                  [formId]="field.formId || ''"
                  [placeholder]="field.placeholder || ''"
                  [required]="field.required || false"
                  [preview]="preview"
                  formControlName="{{ field.name }}">
                </app-form-subform-relation>
              </ng-container>

              <!-- 未知元件類型的處理 -->
              <div *ngSwitchDefault class="unknown-component-warning">
                <div class="alert alert-warning">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{ 'form.builder.unknown_component' | translate: {type: field.type} }}
                </div>
              </div>

              <!-- 個別欄位錯誤訊息 -->
              <div *ngIf="isFieldInvalid(field)" class="field-error-message">
                <small style="color: #d9534f;">
                  <i class="fa fa-exclamation-triangle" style="margin-right: 4px;"></i>
                  {{ 'form.validation.required_field' | translate }}
                </small>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- 表單驗證錯誤訊息 - 只在用戶嘗試提交後顯示，且不在預覽模式時顯示 -->
      <div *ngIf="formGroup.invalid && submitAttempted && !preview" class="form-validation-error">
        <ng-container *ngIf="getInvalidRequiredFields().length > 0">
          <small style="color: #d9534f;">
            <i class="fa fa-exclamation-triangle" style="margin-right: 4px;"></i>
            {{ 'form.validation.missing_required_fields' | translate:{ fields: getInvalidRequiredFieldsText() } }}
          </small>
        </ng-container>
        <ng-container *ngIf="getInvalidRequiredFields().length === 0">
          <small style="color: #d9534f;">{{ 'form.validation.form_invalid' | translate }}</small>
        </ng-container>
      </div>

      <!-- 表單動作按鈕 -->
      <div class="form-actions" *ngIf="!preview && !formfinished && !readonly && !isViewMode">
        <!-- 階段模式的按鈕 -->
        <div class="stage-controls" *ngIf="enableStageMode">
          <button
            *ngIf="canGoToPreviousStage()"
            type="button"
            class="btn btn-secondary"
            (click)="goToPreviousStage()">
            <i class="fas fa-arrow-left"></i>
            {{ 'form.dynamic.previous_stage' | translate }}
          </button>

          <button
            *ngIf="canCompleteCurrentStage()"
            type="button"
            class="btn btn-primary"
            (click)="completeCurrentStage()">
            {{ 'form.dynamic.complete_stage' | translate:{ stageName: currentStage?.name || '' } }}
            <i class="fas fa-arrow-right"></i>
          </button>

          <button
            *ngIf="isLastStage()"
            type="submit"
            class="btn btn-success">
            <i class="fas fa-check"></i>
            {{ 'form.dynamic.submit_form' | translate }}
          </button>
        </div>

        <!-- 原有模式的按鈕 -->
        <div class="normal-controls" *ngIf="!enableStageMode">
          <!-- 如果有訂閱取消事件，顯示取消按鈕 -->
          <button *ngIf="formCancelled.observed" type="button" class="btn btn-secondary" (click)="cancel()">
            {{ 'common.cancel' | translate }}
          </button>
          <button type="submit" class="btn btn-primary">
            {{ formSubmitted.observed ? ('common.save' | translate) : ('form.dynamic.submit' | translate) }}
          </button>
        </div>
      </div>

      <button *ngIf="preview && !readonly && !isViewMode" type="button" (click)="save()">{{ 'form.list.save_to_database' | translate }}</button>
    </form>


  </div>
</div>
